/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class AstraFlowsAPI extends ApiClient {
  constructor() {
    super('kanban/flows', { accountScoped: true });
  }

  get(options = {}) {
    return axios.get(this.url, options);
  }
}

export default new AstraFlowsAPI();
